import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  emptyAnchor: {
    cursor: "pointer",
    userSelect: "none",
  },
}));
